import React, {Component} from "react";
import Package from "./Package";
import Print from "./Print";

export default class Packages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contracts: {
                p001Completed: false,
                p002Completed: false,
                p003Completed: false,
                p004Completed: false,
                p011Completed: false
            }
        };
    }

    checkHandler = (e) => {
        const {onCheck} = this.props;
        onCheck(e.target.id)
    };


    handleSubmit = (e) => {
        e.preventDefault();
        const {onSubmitPackages} = this.props;
        onSubmitPackages();
    };

    completeHandler = ({status, pack}) => {
        const {contracts} = this.state;
        this.setState({contracts: {...contracts, [`p${pack}Completed`]: status}});
    };

    render() {
        const {packages, isPrintClicked} = this.props;
        if (packages.length === 0) {
            return null
        }
        const visible = packages.some(pack => pack.checked);
        const checkPackages = packages.filter(pack => pack.checked);
        const {contracts} = this.state;
        //debugger;
        const p003Check = (pack) => pack.code === '003' ? pack['noFloorPlan'] || pack ['floorPlan'] : true;
        const completed = checkPackages.length
            ? checkPackages.every(pack => contracts[`p${pack.code}Completed`] && p003Check(pack))
            : false;

        return (
            <div className={"packages-container"}>
                <div className={"package-container"}>
                    <div className={"package"}>
                        <div className={"packages-available"}>
                            {packages.map((pack, idx) => {
                                const packageProps = {
                                    code: pack.code,
                                    name: pack.name,
                                    checked: pack.checked,
                                    onClick: this.checkHandler,
                                    onComplete: this.completeHandler,
                                    floorPlanClicked: this.props.floorPlanClicked,
                                    nofloorPlanClicked: this.props.nofloorPlanClicked,
                                    floorPlanChecked: !!pack["floorPlan"],
                                    nofloorPlanChecked: !!pack["noFloorPlan"]
                                };
                                return <Package key={idx}   {...packageProps} />
                            })}
                            <div style={{ textAlign: 'center'}}>
                                <Print
                                    visible={visible}
                                    onClick={this.handleSubmit}
                                    disabled={!completed}
                                    submitted={isPrintClicked}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}